const RetrieveImage = (ref, sizes) => {
  if (ref?.includes("proxyImagenes")) {
    const urlToUse = ref;
    if (urlToUse.includes("width=")) {
      // replace width parameter with the provided sizes
      return urlToUse.replace(/width=\d+/, `width=${sizes}`);
    } else {
      if (urlToUse.includes("?")) {
        return urlToUse + "&width=" + sizes;
      } else {
        return urlToUse + "?width=" + sizes;
      }
    }
  }

  if (ref != null && typeof ref === "string" && ref !== "") {
    var baseURI =
      "https://firebasestorage.googleapis.com/v0/b/micatalogovirtual-7bfd1.appspot.com/o/" +
      encodeURIComponent(ref.replace(/^\//, "")) +
      (sizes && !ref.includes(".jpg") && !ref.includes(".png")
        ? "_" + sizes + "w"
        : "") +
      "?alt=media";
    return baseURI;
  } else {
    if (!sizes) {
      sizes = "150x150";
    }
    const domain = window.location.host;
    const subdomain = domain.split(".")[0];
    return "https://placehold.co/" + sizes + "?text=" + subdomain;
  }
};

export default RetrieveImage;
